import * as THREE from 'three';
import Experience from './Experience.js';
import Dungeon from './Portal/Dungeon.js';
import RaycasterObjects from './Portal/RaycasterObjects.js';

export default class World {
  constructor(_options) {
    this.experience = new Experience();
    this.config = this.experience.config;
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;
    this.sizes = this.experience.sizes;
    this.onProjects = false;

    this.resources.on('groupEnd', (_group) => {
      this.setPortals();
      this.setKeyDowns();
    });
  }

  setPortals() {
    this.dungeon = new Dungeon();
    this.raycasterObjects = new RaycasterObjects();
    // gsap.to('.arrow', { y: 12, ease: 'power1.inOut', repeat: -1, yoyo: true });
  }
  setKeyDowns() {
    document.addEventListener('keydown', (e) => {
      console.log(e);
      if (
        e.key === 'ArrowLeft' &&
        this.experience.camera.logic.mode === 'projects'
      ) {
        this.dungeon.prevProject();
      }
      if (
        e.key === 'ArrowRight' &&
        this.experience.camera.logic.mode === 'projects'
      ) {
        this.dungeon.nextProject();
      }
    });
  }
  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  resize() {}

  update() {
    if (this.dungeon) this.dungeon.update();
  }

  destroy() {}
}
